import React from "react";
import Lottie from "lottie-react";
import Header2 from "../Header2/Header2";
import Footer2 from "../Footer2/Footer2";
import "./Pedagogia.css";

// Animaciones
import pedagogiaAnim from "../../Assets/Animations/Training.json";
import planningAnim from "../../Assets/Animations/Submitted (1).json";
import classAnim from "../../Assets/Animations/Classroom.json";
import assessmentAnim from "../../Assets/Animations/note.json";
import rolesAnim from "../../Assets/Animations/Dynamic Role.json";
import digitalizationAnim from "../../Assets/Animations/Activity.json";
import configAnim from "../../Assets/Animations/Setup (1).json";

function Pedagogia() {
  return (
    <>
      <Header2 />
      <section className="pedagogia-section">

        {/* Fondo decorativo */}
        <div className="pedagogia-bg-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>

        {/* HERO PEDAGOGÍA */}
        <div className="pedagogia-hero">
          <div className="pedagogia-hero-content">

            {/* Contenido textual */}
            <div className="pedagogia-hero-text">
              <span className="pedagogia-badge">
                <i className='bx bx-book-open'></i>
                Gestión pedagógica inteligente
              </span>

              <h1 className="pedagogia-title">
                Automatizá la gestión docente,
                <span className="title-highlight"> potenciá el aprendizaje</span>
              </h1>

              <p className="pedagogia-subtitle">
                Planificaciones automáticas, clases digitales, evaluaciones integradas
                y accesos diferenciados para docentes y estudiantes.
                Todo en una plataforma pensada por y para educadores.
              </p>

              {/* Stats pedagógicas */}
              <div className="pedagogia-stats">
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className='bx bx-time-five'></i>
                  </div>
                  <div className="stat-content">
                    <span className="stat-number">-50%</span>
                    <span className="stat-label">Tiempo de planificación</span>
                  </div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className='bx bx-group'></i>
                  </div>
                  <div className="stat-content">
                    <span className="stat-number">+40%</span>
                    <span className="stat-label">Productividad docente</span>
                  </div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className='bx bx-file-find'></i>
                  </div>
                  <div className="stat-content">
                    <span className="stat-number">100%</span>
                    <span className="stat-label">Documentación digital</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Icono animado principal */}
            <div className="pedagogia-icon-container">
              <div className="icon-wrapper">
                <Lottie
                  animationData={pedagogiaAnim}
                  loop
                  className="pedagogia-main-anim"
                />
                <div className="icon-glow"></div>
              </div>
              <div className="icon-floaters">
                <div className="floater floater-1">
                  <i className='bx bx-calendar-check'></i>
                </div>
                <div className="floater floater-2">
                  <i className='bx bx-chalkboard'></i>
                </div>
                <div className="floater floater-3">
                  <i className='bx bx-file'></i>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* GRID DE FUNCIONALIDADES PEDAGÓGICAS */}
        <div className="pedagogia-grid-section">
          <div className="section-header">
            <h2>
              Todo lo que tu equipo docente necesita,
              <span> en un solo ecosistema</span>
            </h2>
            <p>
              Seis pilares que transforman la gestión pedagógica diaria,
              desde la planificación hasta la documentación automática.
            </p>
          </div>

          <div className="pedagogia-grid">

            {/* 1. Automatización de planificaciones */}
            <div className="pedagogia-card">
              <div className="card-icon">
                <Lottie animationData={planningAnim} loop />
              </div>
              <div className="card-content">
                <h4>Automatización de planificaciones</h4>
                <p>
                  Creación y organización automática de planificaciones
                  académicas con estructuras institucionales configurables.
                </p>
                <ul className="card-features">
                  <li><i className='bx bx-check'></i> Planificaciones</li>
                  <li><i className='bx bx-check'></i> Secuencias didácticas</li>
                  <li><i className='bx bx-check'></i> Cuestionarios automatizacios a partir de material.</li>
                </ul>
              </div>
              <div className="card-footer">
                <span className="card-tag">Ahorro de tiempo</span>
              </div>
            </div>

            {/* 2. Desarrollo de clases y contenidos */}
            <div className="pedagogia-card">
              <div className="card-icon">
                <Lottie animationData={classAnim} loop />
              </div>
              <div className="card-content">
                <h4>Desarrollo de clases y contenidos</h4>
                <p>
                  Gestión digital completa de clases, actividades y recursos
                  pedagógicos, accesibles desde cualquier dispositivo.
                </p>
                <ul className="card-features">
                  <li><i className='bx bx-check'></i> Repositorio multimedia</li>
                  <li><i className='bx bx-check'></i> Material por unidad</li>
                  <li><i className='bx bx-check'></i> Acceso desde cualquier dispositivo</li>
                </ul>
              </div>
              <div className="card-footer">
                <span className="card-tag">Aula virtual</span>
              </div>
            </div>

            {/* 3. Trabajos prácticos y evaluaciones */}
            <div className="pedagogia-card">
              <div className="card-icon">
                <Lottie animationData={assessmentAnim} loop />
              </div>
              <div className="card-content">
                <h4>Trabajos prácticos y evaluaciones</h4>
                <p>
                  Asignación, seguimiento y calificación de trabajos prácticos,
                  con rúbricas y devoluciones personalizadas.
                </p>
                <ul className="card-features">
                  <li><i className='bx bx-check'></i> Planificaciones configurables</li>
                  <li><i className='bx bx-check'></i> Feedback y consultas</li>
                  <li><i className='bx bx-check'></i> Notas integradas</li>
                </ul>
              </div>
              <div className="card-footer">
                <span className="card-tag">Evaluación formativa</span>
              </div>
            </div>

            {/* 4. Configuraciones académicas flexibles */}
            <div className="pedagogia-card">
              <div className="card-icon">
                <Lottie animationData={configAnim} loop />
              </div>
              <div className="card-content">
                <h4>Configuraciones académicas flexibles</h4>
                <p>
                  Adaptá criterios de evaluación, estructuras curriculares
                  y dinámicas institucionales sin limitaciones.
                </p>
                <ul className="card-features">
                  <li><i className='bx bx-check'></i> Períodos personalizables</li>
                  <li><i className='bx bx-check'></i> Escalas propias</li>
                  <li><i className='bx bx-check'></i> Áreas y materias</li>
                </ul>
              </div>
              <div className="card-footer">
                <span className="card-tag">A medida</span>
              </div>
            </div>

            {/* 5. Accesos por roles: estudiantes y docentes */}
            <div className="pedagogia-card">
              <div className="card-icon">
                <Lottie animationData={rolesAnim} loop />
              </div>
              <div className="card-content">
                <h4>Accesos por roles</h4>
                <p>
                  Entornos diferenciados para docentes, estudiantes y directivos,
                  cada uno con las herramientas que necesita.
                </p>
                <ul className="card-features">
                  <li><i className='bx bx-check'></i> Panel docente integral</li>
                  <li><i className='bx bx-check'></i> Perfil estudiante</li>
                  <li><i className='bx bx-check'></i> Vista directiva</li>
                </ul>
              </div>
              <div className="card-footer">
                <span className="card-tag">Experiencia personalizada</span>
              </div>
            </div>

            {/* 6. Digitalización automática de documentos */}
            <div className="pedagogia-card">
              <div className="card-icon">
                <Lottie animationData={digitalizationAnim} loop />
              </div>
              <div className="card-content">
                <h4>Digitalización automática de documentos</h4>
                <p>
                  Digitalizacion automática de documentos fisicos. Cero papeles, cero pérdidas.
                </p>
                <ul className="card-features">
                  <li><i className='bx bx-check'></i> Actas digitales</li>
                  <li><i className='bx bx-check'></i> Reportes automáticos</li>
                  <li><i className='bx bx-check'></i> Historial académico</li>
                </ul>
              </div>
              <div className="card-footer">
                <span className="card-tag">Gestión sin papeles</span>
              </div>
            </div>

          </div>
        </div>

        {/* VALOR DIFERENCIAL: PENSADO POR EDUCADORES */}
        <div className="pedagogia-approach">
          <div className="approach-container">
            <div className="approach-icon">
              <i className='bx bx-target-lock'></i>
            </div>
            <div className="approach-content">
              <h3 className="approach-title">
                Diseñado por y para educadores
              </h3>
              <p className="approach-description">
                Cada funcionalidad pedagógica de TRESA nace del diálogo con
                docentes y directivos. No automatizamos por automatizar:
                liberamos tiempo para que enseñes mejor.
              </p>
              <div className="approach-tags">
                <span className="approach-tag">Docentes concentrados</span>
                <span className="approach-tag">Actualizaciones pedagógicas</span>
                <span className="approach-tag">Soporte especializado</span>
              </div>
            </div>
          </div>
        </div>

        {/* BENEFICIOS TRANSVERSALES */}
        <div className="pedagogia-benefits">
          <div className="benefits-container">
            <div className="benefits-header">
              <h2>
                Más que herramientas,
                <span> un aliado pedagógico</span>
              </h2>
              <p>
                TRESA no solo digitaliza: transforma la gestión del aula
                en una experiencia colaborativa y centrada en el aprendizaje.
              </p>
            </div>

            <div className="benefits-grid">
              <div className="benefit-item">
                <div className="benefit-icon">
                  <i className='bx bx-chalkboard'></i>
                </div>
                <h4>Docentes enfocados</h4>
                <p>
                  Menos tareas administrativas, más tiempo para planificar
                  con creatividad y acompañar trayectorias.
                </p>
              </div>

              <div className="benefit-item">
                <div className="benefit-icon">
                  <i className='bx bx-bar-chart-alt-2'></i>
                </div>
                <h4>Seguimiento en tiempo real</h4>
                <p>
                  Visualizá el progreso de cursos y estudiantes con
                  dashboards pedagógicos claros y accionables.
                </p>
              </div>

              <div className="benefit-item">
                <div className="benefit-icon">
                  <i className='bx bx-link-alt'></i>
                </div>
                <h4>Todo integrado</h4>
                <p>
                  Planificaciones, contenidos, evaluaciones y documentos
                  conectados en un mismo flujo de trabajo.
                </p>
              </div>

              <div className="benefit-item">
                <div className="benefit-icon">
                  <i className='bx bx-support'></i>
                </div>
                <h4>Acompañamiento real</h4>
                <p>
                  Capacitación docente continua y soporte pedagógico
                  para que la tecnología realmente sume.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CIERRE EMOCIONAL - MENSAJE CLAVE */}
        <div className="pedagogia-closing">
          <div className="closing-container">
            <div className="closing-icon">
              <i className='bx bx-heart-circle'></i>
            </div>
            <h3 className="closing-title">
              Menos carga operativa.
              <span> Más foco en enseñar.</span>
            </h3>
            <p className="closing-text">
              Tresaedu libera a tus docentes de la burocracia administrativa
              para que puedan concentrarse en lo que realmente importa:
              el aprendizaje de tus estudiantes.
            </p>

            {/* CTA pedagógico */}
            <div className="pedagogia-cta">
              <a
                href='https://wa.me/message/ORWIOZ4UP74NM1' target="_blank"
                rel="noopener noreferrer"
                className="cta-button"
              >
                <i className='bx bx-book-reader'></i>
                <span>Potenciar la pedagogía de mi institución</span>
              </a>
              <p className="cta-subtext">
                Demo personalizada para equipos docentes · Sin costo
              </p>
            </div>
          </div>
        </div>

      </section>
      <Footer2 />
    </>
  );
}

export default Pedagogia;